export const plans = [
  {
    code: "free",
    name: "Free",
    family: "Free",
    monthly: 0,
    annual: 0,
    storage: "10 GB",
    logs: "5 GB",
    requests: "500k",
    fairUse: false,
    note: "10 GB CDN Storage + 5 GB Logs. Perfect for getting started.",
  },
  {
    code: "lite",
    name: "Lite",
    family: "Media + CDN",
    monthly: 499,
    annual: 5489,
    storage: "250 GB",
    logs: "5 GB",
    requests: "2.5M",
    fairUse: false,
    note: "250 GB CDN Storage + 5 GB Logs included.",
  },
  {
    code: "starter",
    name: "Starter",
    family: "Media + CDN",
    monthly: 999,
    annual: 10989,
    storage: "500 GB",
    logs: "5 GB",
    requests: "6M",
    fairUse: false,
    note: "500 GB CDN Storage + 5 GB Logs included.",
  },
  {
    code: "pro",
    name: "Pro",
    family: "Media + CDN",
    monthly: 3499,
    annual: 38489,
    storage: "2 TB",
    logs: "5 GB",
    requests: "30M",
    fairUse: true,
    note: "2 TB CDN Storage + 5 GB Logs.",
  },
  {
    code: "titan",
    name: "Titan",
    family: "Media + CDN",
    monthly: 7999,
    annual: 87989,
    storage: "5 TB",
    logs: "5 GB",
    requests: "75M",
    fairUse: true,
    note: "5 TB CDN Storage + 5 GB Logs.",
  },
  {
    code: "monster",
    name: "Monster",
    family: "Media + CDN",
    monthly: 14999,
    annual: 164989,
    storage: "10 TB",
    logs: "5 GB",
    requests: "150M",
    fairUse: true,
    note: "10 TB CDN Storage + 5 GB Logs.",
  },
  {
    code: "log_entry",
    name: "Log Entry",
    family: "Logs",
    monthly: 499,
    annual: 5489,
    storage: "10 GB",
    logs: "250 GB",
    requests: "Unlimited queries",
    fairUse: false,
    note: "250 GB Log Observatory + 10 GB CDN. Unlimited queries & searches.",
  },
  {
    code: "log_pro",
    name: "Log Pro",
    family: "Logs",
    monthly: 1499,
    annual: 16489,
    storage: "10 GB",
    logs: "1 TB",
    requests: "Unlimited queries",
    fairUse: false,
    note: "1 TB Log Observatory + 10 GB CDN. Unlimited queries & searches.",
  },
  {
    code: "log_titan",
    name: "Log Titan",
    family: "Logs",
    monthly: 3999,
    annual: 43989,
    storage: "10 GB",
    logs: "3 TB",
    requests: "Unlimited queries",
    fairUse: false,
    note: "3 TB Log Observatory + 10 GB CDN. Deep telemetry at network scale.",
  },
  {
    code: "community_pro",
    name: "Community Pro",
    family: "All in one",
    monthly: 2999,
    annual: 32989,
    storage: "1 TB",
    logs: "500 GB",
    requests: "20M",
    fairUse: true,
    note: "1 TB CDN Storage + 500 GB Logs.",
  },
  {
    code: "network_titan",
    name: "Network Titan",
    family: "All in one",
    monthly: 8999,
    annual: 98989,
    storage: "4 TB",
    logs: "1.5 TB",
    requests: "80M",
    fairUse: true,
    note: "4 TB CDN Storage + 1.5 TB Logs.",
  },
] as const;
